<!--
  NP Šumava, kůrovcové souše - doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row" v-if="IsInit">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendDynamicSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-card width="240" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="DemoList" v-model="VybDemo"
        item-text="nazev" item-value="kod" dense hide-details="true" background-color="info" height="40">
      </v-overflow-btn>
    </v-card>

    <v-card width="368" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete "
        :items="DemoList.find((item) => item.kod == VybDemo).seznam" v-model="VybDemoObj" dense item-text="nazev"
        hide-details="true" height="40" background-color="info" return-object>
      </v-overflow-btn>
    </v-card>


    <Teleport to="#MapLayerLegendDynamicObj" v-if="ViewLeg">

      <!-- Legenda bez výběru ( zobrazeno v měřítku nad VybLeg.EditableMinScale)  -->
      <v-list dense color="transparent">
        <v-list-item v-for="item in VybLeg.Seznam" :key="item.Kod">

          <!-- Se šrafou -->
          <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
            <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
              <defs>
                <!-- definice výplně - šrafy -->
                <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth" :height="item.Srafa.PatternHeight"
                  patternUnits="userSpaceOnUse">
                  <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                    :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                  </path>
                </pattern>
              </defs>
              <!-- případná barva podkladu -->
              <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
              <!-- výplň - šrafa -->
              <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
            </svg>
          </v-list-item-avatar>

          <!-- Se značkou -->
          <v-list-item-avatar v-else-if="item.Znacka" class="my-1" rounded color="transparent">
            <svg xmlns="http://www.w3.org/2000/svg" :color="item.Barva" v-html="item.Znacka.Svg">
            </svg>
          </v-list-item-avatar>

          <!-- Bez šrafy -->
          <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

          <v-list-item-title v-text="item.Popis"></v-list-item-title>
        </v-list-item>


      </v-list>

    </Teleport>



  </div>
</template>

<script>

import AppDataDemo from "../../../assets/MapOt_Demo.json";

export default {

  components: {
    Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},
  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,
      // Legenda
      VybLeg: null,
      // Vybrané prvky legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,

      // Jméno legendy
      MapLayerLegendDynamic_contentName: "MapOT_Demo_legend",
      MapLayerLegendDynamic_Title: "Demonstrační objekty",

      DemoList: [
        { nazev: "Demonstrační objekty", kod: "Uhul_demo_do", seznam: [] },
        { nazev: "Lesnické parky", kod: "Uhul_demo_lp", seznam: [] },
        { nazev: "Demonstrační plochy", kod: "Uhul_demo_dp", seznam: [] }
      ],

      VybDemo: "Uhul_demo_do",
      VybDemoObj: null,

    };
  },



  computed: {
    MapLayer_Demo: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_demo");
    },
    MapLayer_DemoDeob: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_demo_do").layer;
    },
    MapLayer_DemoLepa: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_demo_lp").layer;
    },
    MapLayer_DemoDepl: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_demo_dp").layer;
    },




  },

  watch: {

    // Změna zobrazení jednotlivých objektů
    VybDemoObj: function (value) {
      // console.log("VybDemoObj")
      // console.log(value)
      // console.log(value.data.shape.bounds)
      if (value.data.shape.type == 1) {
        this.MapViewZoomToScalePoint(1 / 10000, value.data.shape)
      } else {
        this.MapViewZoomToBounds(value.data.shape.bounds)
      }

      this.MapQueryFeature_GetInfo(value.data, this.MapLegendLayers.find((item) => item.id == this.VybDemo).layer)

    },

    // Změna zobrazení vlastní legendylegendy
    MapLayerLegendDynamic_content: function (value) {
      // console.log("MapLayerLegendDynamic_content")
      // console.log(value)
      if (value == this.MapLayerLegendDynamic_contentName) { this.ViewLeg = true } else { this.ViewLeg = false }
    },

  },

  methods: {
    // Zobrazení dynamické mapové legendy - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function () {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapLayerLegendDynamicSet', this.MapLayer_Demo.id, this.MapLayerLegendDynamic_Title, this.MapLayerLegendDynamic_contentName);
    },

    // Změna mapového výřezu podle obdelníku
    MapViewZoomToBounds: function (value) {
      this.$emit('MapViewZoomToBounds', value);
    },

    // Změna mapového výřezu na cílové měřítko a středový bod
    MapViewZoomToScalePoint: function (vTargetScale, vPoint) {
      this.$emit('MapViewZoomToScalePoint', vTargetScale, vPoint);
    },

    MapQueryFeature_GetInfo: function (feature, layer) {
      this.$emit('MapQueryFeature_GetInfo', feature, layer);
    },


  },

  mounted() {
    // První spuštění nástroje
    //console.log("DEMO start");

    // Základní nastavení - 
    // Načtení legendy
    // this.VybLeg = AppDataKrvc.Legenda;
    // // Vybrat vše v legendě
    // this.VybLegList = this.VybLeg.Seznam.map(function (l) {
    //   return l.Kod
    // })

    this.MAP.layerTree.whenReady().then(() => {

      // Načtení dat z vrstev
      var deobSeznam = [];
      this.MapLayer_DemoDeob.workingSet.get().forEach(function (item) {
        deobSeznam.push({ nazev: item._properties.DO_NAZ, data: item })
      });
      var deobSeznamSort = deobSeznam.sort(function (a, b) {
        return a.nazev.localeCompare(b.nazev);
      })
      this.DemoList.find((item) => item.kod == "Uhul_demo_do").seznam = deobSeznamSort;

      var lepaSeznam = [];
      this.MapLayer_DemoLepa.workingSet.get().forEach(function (item) {
        lepaSeznam.push({ nazev: item._properties.LP_NAZ, data: item })
      });
      var lepaSeznamSort = lepaSeznam.sort(function (a, b) {
        return a.nazev.localeCompare(b.nazev);
      })
      this.DemoList.find((item) => item.kod == "Uhul_demo_lp").seznam = lepaSeznamSort;

      var deplSeznam = [];
      this.MapLayer_DemoDepl.workingSet.get().forEach(function (item) {
        deplSeznam.push({ nazev: item._properties.DP_NAZ, data: item })
      });
      var deplSeznamSort = deplSeznam.sort(function (a, b) {
        return a.nazev.localeCompare(b.nazev);
      })
      this.DemoList.find((item) => item.kod == "Uhul_demo_dp").seznam = deplSeznamSort;

      // Načtení legendy
      this.VybLeg = AppDataDemo.Legenda;

      // Objekt aktivován
      this.IsInit = true;

    })

    // // Legenda vrstvy
    // this.MapLayerLegendDynamicAdd()

  },
};








</script>